import { Close, KeyboardArrowDown } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
  Typography
} from '@mui/material';
import { useState } from 'react';
import PatientAutocomplete from '../../Common/components/Patients/PatientAutocomplete';
import {
  dialogHeaderStyles,
  sectionTitleSx,
  textFieldSx,
  menuProps
} from '../../Common/components/Styles/InputStyles';
import CommonDialogActions from '../../Common/components/CommonDialogActions';

const patients = [
  {
    dob: '03/06/2006 (20 yrs)',
    mr: '22351612',
    name: 'William, Gwen Marry',
    sex: 'Female'
  },
  {
    dob: '05/12/1998 (28 yrs)',
    mr: '22351684',
    name: 'Philip, Cammiee John',
    sex: 'Female'
  },
  {
    dob: '11/22/1985 (40 yrs)',
    mr: '22351690',
    name: 'Johnson, Arjun Kumar',
    sex: 'Male'
  },
  {
    dob: '08/14/1992 (33 yrs)',
    mr: '22351701',
    name: 'Mary, Anitha Rose',
    sex: 'Female'
  },
  {
    dob: '01/19/1978 (48 yrs)',
    mr: '22351718',
    name: 'Kumar, Ravi Shankar',
    sex: 'Male'
  }
];

const InvitePatientModal = ({ open, onClose }) => {
  const [form, setForm] = useState({
    search: '',
    lastName: '',
    firstName: '',
    country: '+1',
    mobile: '',
    email: '',
    confirmEmail: ''
  });

  const handleChange = field => event => {
    setForm(prev => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  const handleSelectPatient = patient => {
    console.log('Selected patient:', patient);

    // Add patient navigation here.
    // Example:
    // navigate(`/soap/${patient.mr}`);
  };

  const isValid =
    form.lastName &&
    form.firstName &&
    form.email &&
    form.confirmEmail &&
    form.email === form.confirmEmail;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '6px'
        }
      }}>
      <DialogTitle sx={dialogHeaderStyles.dialogheader}>
        <Box>
          <Typography sx={dialogHeaderStyles.title}>
            Invite to Patient Portal & App
          </Typography>
          <Typography sx={dialogHeaderStyles.subtitle}>
            Send an invitation to activate the EHRZip Connect patient portal and
            mobile app.
          </Typography>
        </Box>

        <IconButton
          aria-label="Close"
          onClick={onClose}
          size="small"
          sx={dialogHeaderStyles.dialogheaderclose}>
          <Close sx={{ fontSize: 22 }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: 2, my: 2 }}>
        <Stack spacing={1.8}>
          <Typography sx={sectionTitleSx}>PATIENT</Typography>

          <PatientAutocomplete
            onSelectPatient={handleSelectPatient}
            patients={patients}
            width="100%"
            placeholder="Search by patient name or MR#"
          />
          <FormControl fullWidth size="small" sx={textFieldSx} required>
            <InputLabel htmlFor="last-name">Last Name </InputLabel>
            <OutlinedInput
              id="last-name"
              label="Last Name "
              value={form.lastName}
              onChange={handleChange('lastName')}
            />
          </FormControl>

          <FormControl fullWidth size="small" sx={textFieldSx} required>
            <InputLabel htmlFor="first-name">First Name </InputLabel>
            <OutlinedInput
              id="first-name"
              label="First Name "
              value={form.firstName}
              onChange={handleChange('firstName')}
            />
          </FormControl>
          <Stack direction="row" spacing={1}>
            <FormControl
              fullWidth
              size="small"
              sx={{ ...textFieldSx, width: '25%' }}>
              <InputLabel id="country-label">Country code</InputLabel>
              <Select
                labelId="country-label"
                id="country"
                MenuProps={menuProps}
                value={form.country}
                label="Country code"
                onChange={handleChange('country')}
                IconComponent={KeyboardArrowDown}>
                <MenuItem value="+1">+1</MenuItem>
                <MenuItem value="+91">+91</MenuItem>
              </Select>
            </FormControl>

            <FormControl
              fullWidth
              size="small"
              sx={{ ...textFieldSx, width: '75%' }}>
              <InputLabel htmlFor="mobile">Mobile Number</InputLabel>
              <OutlinedInput
                id="mobile"
                label="Mobile Number"
                value={form.mobile}
                onChange={handleChange('mobile')}
              />
            </FormControl>
          </Stack>

          <FormControl fullWidth size="small" sx={textFieldSx} required>
            <InputLabel htmlFor="email">Email Address </InputLabel>
            <OutlinedInput
              id="email"
              label="Email Address "
              value={form.email}
              onChange={handleChange('email')}
            />
          </FormControl>

          <FormControl fullWidth size="small" sx={textFieldSx} required>
            <InputLabel htmlFor="confirm-email">
              Confirm Email Address
            </InputLabel>
            <OutlinedInput
              id="confirm-email"
              label="Confirm Email Address "
              value={form.confirmEmail}
              onChange={handleChange('confirmEmail')}
            />
          </FormControl>
        </Stack>
      </DialogContent>
      <CommonDialogActions
        onCancel={onClose}
        onSubmit={onClose}
        submitText="Send Invite"
        disabled={!isValid}
      />
    </Dialog>
  );
};

export default InvitePatientModal;
